export default __webpack_public_path__ + "static/media/storybook.42227877.png";